// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__2mCo_","title":"Header_title__1_FkL","row":"Header_row__tnTDP","danger":"Header_danger__1lXbE","success":"Header_success__1fIo5"};